<template>
  <div class="container-fluid mt-2 p-2">
    <h2>Neues Modul laden</h2>
    <div class="row" v-if="!loaded">
      <div class="col-md">
        <div class="form-inline">
          <label>Modul ZIP Datei:</label>
          <div class="input-group ml-3">
            <div class="input-group-prepend">
              <button id="upload" @click="uploadModule" class="btn btn-secondary">Upload</button>
            </div>
            <div class="custom-file">
              <input type="file" @change="updateFilename" class="custom-file-input" id="processfile" aria-describedby="upgroup">
              <label class="custom-file-label" for="upgroup">{{ filename }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md">
        <p>Laden Sie hier das gewünschte Modul in den Connector. Dazu die vorhandene ZIP Datei links eingeben.</p>
      </div>
    </div>
    <div class="wrapper" v-if="loaded">
      <div class="btn-toolbar justify-content-between">
        <button @click="installModule" class="btn btn-primary">Modul aktivieren</button>
        <button @click="goBack" class="btn btn-secondary">Zur&uuml;ck</button>
      </div>
      <div class="row mt-2">
        <div class="col-md">
          <div class="form-group">
            <label>ID</label>
            <input type="text" disabled class="form-control" :value="module.module_id"/>
          </div>
          <div class="form-group">
            <label>Name</label>
            <input type="text" disabled class="form-control" :value="module.name"/>
          </div>
          <div class="form-group">
            <label>Version</label>
            <input type="text" disabled class="form-control" :value="module.version"/>
          </div>
          <div class="form-group">
            <label>Lokale Resource ID</label>
            <input type="text" disabled class="form-control" :value="module.resource_id"/>
          </div>
          <hr/>
          <div class="form-group">
            <JsonViewer :data="module.config"/>
          </div>
        </div>
        <div class="col-md">
          <b-tabs v-model="tabidx">
            <b-tab title="Infos">
              <div class="wrapper" v-html="module.info">
              </div>
            </b-tab>
            <b-tab title="Parameter">
                <div v-for="(val,key) in module.config.parameter" :key="key" class="form-group">
                    <label>{{ key }}</label>
                    <input type="text" class="form-control" v-model="iparam[key]"/>
                </div>
            </b-tab>
            <b-tab title="Verlauf">
              <b-table :items="rundata.results" :fields="fields" :tbody-tr-class="rowClass">
                <template v-slot:cell(ridx)="data">
                  {{ data.index+1 }}
                </template>
                <template v-slot:cell(status)="data">
                  <font-awesome-icon v-if="data.item.status==0" icon="check"/>
                  <font-awesome-icon v-else-if="data.item.status==1" icon="edit"/>
                  <div class="wrapper" v-else>
                    <b-button id="popover-target-1">
                      <font-awesome-icon icon="exclamation-triangle"/>
                    </b-button>
                    <b-popover target="popover-target-1" triggers="hover" placement="top">
                      <template v-slot:title>Fehler Text</template>
                      {{ data.item.error }}
                    </b-popover>
                  </div>
                </template>
              </b-table>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <div class="container">
      </div>
    </div>
  </div>
</template>

<script>
import router from '../../../router'
import conmodules from '@/modules/conmodules.js'
import JsonViewer from '@/components/JsonViewer.vue'

export default {
  name: 'ModuleUpload',
  components: {
    JsonViewer,
  },
  data() {
    return {
      filename: '',
      loaded: false,
      module: {},
      iparam: {},
      rundata: {},
      tabidx: 0,
      fields: [
        { label: 'ID', key: 'ridx' },
        { label: 'Module', key: 'module' },
        { label: 'Step', key: 'sid'},
        { label: 'Ergebnis', key: 'status'},
      ]
    }
  },
  methods: {
    goBack() {
      router.push({name: 'ModulesOverview'});
    },
    rowClass: function(item,type) {
      if (!item || type !== 'row') return
      console.log(item.status);
      if (item.status == '10') {
        console.log('ERR DCOLUMN');
        return 'error';
      }
      return 'success';
    },
    uploadModule: function() {
      console.log('um');
      var files = document.getElementById('processfile').files;
      var self = this;
      conmodules.preloadmodule(this,files,function(data) {
        self.module = data;
        self.loaded = true;
        console.log("module json",data);
      })
    },
    installModule: function() {
      console.log('install');
      if (!confirm('Möchten Sie das Modul wirklich aktivieren?')) {
        return;
      }
      var body = { resource_id: this.module.resource_id, params: this.iparam };
      var self = this;
      conmodules.runinstall(this,body,function(data) {
        console.log(data);
        self.rundata = data;
        if (data.success) {
          self.$bvToast.toast('Modul erfolgreich installiert.',{title:'Module',variant:'success'});
        } else {
          self.$bvToast.toast('Fehler beim Installieren, bitte am Protokoll prüfen.',{title:'Module',variant:'danger'});
          self.tabidx = 2;
        }
      });
    },
    updateFilename: function() {
      var ifile = document.getElementById('processfile');
      if (ifile.files && ifile.files.length > 0) {
        this.filename = ifile.files[0].name;
      }
    }
  }
}
</script>

<style>
tr.error {
  background-color: #faa;
}
tr.success {
  background-color: #afa;
}
</style>
